import { useCallback, useState } from 'react'
import { Airport, airportSchema } from '../../../api/searchAirports'

export const RECENT_SEARCHES_KEY = 'recentFlightSearches'

const isValidAirport = (airport: any): airport is Airport => {
  const parsedResult = airportSchema.safeParse(airport)
  return parsedResult.success
}

export const useRecentSearches = () => {
  const [recentSearches, setRecentSearches] = useState<Airport[]>(() => {
    try {
      const storedSearches = localStorage.getItem(RECENT_SEARCHES_KEY)
      if (!storedSearches) return []

      const parsed = JSON.parse(storedSearches)
      return Array.isArray(parsed) ? parsed.filter(isValidAirport) : []
    } catch (error) {
      console.error('Failed to parse recent searches from local storage', error)
      return []
    }
  })

  const saveSearch = useCallback((airport: Airport) => {
    setRecentSearches((prev) => {
      const filtered = prev.filter((item) => item.code !== airport.code)
      const newRecentSearches = [airport, ...filtered].slice(0, 3)
      localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(newRecentSearches))

      return newRecentSearches
    })
  }, [])

  return { recentSearches, saveSearch }
}
